module.exports = __webpack_public_path__ + "img/value1.e490e241.png";